const animation = () => {

    const animatic = new WOW (
        {
            boxClass        : 'wow',
            animateClass    : 'animated',
            offset          : 200,
            mobile          : false,
            scrollContainer : '#website-wrapper',
            resetAnimation  : false,
            callback        : function(box) {}
        }
    );

    animatic.init();

}